import React, { useEffect, useState, useContext, useRef } from 'react';
import {
  Home,
  Assessment,
  WorkOutline,
  Insights,
  AccountBalanceWallet,
  Close
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { WebSocketContext } from '../WebSocketContext';
import './NavBar.css';
import { apiAppFetch } from '../utils/apiFetch';

function NavBar() {
  const { isDarkMode } = useTheme();
  const { userDetails } = useContext(WebSocketContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = React.useState(location.pathname);
  const [marqueeText, setMarqueeText] = useState(null);
  const [showMarginBox, setShowMarginBox] = useState(false);
  const marginBoxRef = useRef(null);

  const getTodayScrollText = async () => {
    try {
      const response = await apiAppFetch('getTodayScrollText', {
        method: 'POST',
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        return;
      }

      const data = await response.json();
      setMarqueeText(data.text);
    } catch (error) {
      // fetch failed silently
    }
  };

  // useEffect(() => {
  //   getTodayScrollText();
  // }, []);

  useEffect(() => {
    setValue(location.pathname);
  }, [location.pathname]);

  const handleChange = (path) => {
    setShowMarginBox(false);
    setValue(path);
    navigate(path);
  };

  const toggleMarginBox = () => {
    setShowMarginBox((open) => !open);
  };


  const formatMoney = (value) =>
    `₹${Number(value || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  const bookedPnL = Number(userDetails?.m2m_balance || 0) - Number(userDetails?.m2m_limit || 0);
  const usedMargin = Number(userDetails?.m2m_balance || 0) - Number(userDetails?.availableMargin || 0);

  const navItems = [
    { path: '/', label: 'Home', icon: <Home />, match: (path) => path === '/' },
    { path: '/trades', label: 'Trades', icon: <Assessment />, match: (path) => path === '/trades' },
    { path: 'summary', label: 'Summary', icon: <AccountBalanceWallet />, match: () => showMarginBox },
    { path: '/positions', label: 'Portfolio', icon: <WorkOutline />, match: (path) => path === '/positions' || path === '/portfolio' },
    { path: '/performance', label: 'Deals', icon: <Insights />, match: (path) => path === '/performance' }
  ];

  return (
    <div className={`bottom-navigation ${isDarkMode ? 'dark-theme' : 'light-theme'}`} data-theme={isDarkMode ? 'dark' : 'light'}>
      {showMarginBox && (
        <div className="summary-overlay" onClick={toggleMarginBox}>
          <div className="summary-sheet" ref={marginBoxRef} onClick={(event) => event.stopPropagation()}>
            <div className="summary-handle" />
            <div className="summary-head">
              <h3>Account Summary</h3>
              <button type="button" className="summary-close" onClick={toggleMarginBox} aria-label="Close">
                <Close />
              </button>
            </div>
            <div className="summary-grid">
              <div className="summary-card">
                <span>M2M Limit</span>
                <strong className={Number(userDetails?.m2m_limit || 0) < 0 ? 'negative' : 'positive'}>
                  {formatMoney(userDetails?.m2m_limit)}
                </strong>
              </div>
              <div className="summary-card">
                <span>Booked P&L</span>
                <strong className={bookedPnL < 0 ? 'negative' : 'positive'}>
                  {formatMoney(bookedPnL)}
                </strong>
              </div>
              <div className="summary-card">
                <span>Used Margin</span>
                <strong>{formatMoney(usedMargin)}</strong>
              </div>
              <div className="summary-card">
                <span>Free Margin</span>
                <strong className="positive">{formatMoney(userDetails?.availableMargin)}</strong>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="nav-container">
        {navItems.map((item) => (
          <button
            key={item.label}
            type="button"
            className={`nav-item${item.match(value) ? ' active' : ''}`}
            onClick={() => (item.path === 'summary' ? toggleMarginBox() : handleChange(item.path))}
          >
            <span className="nav-icon">{item.icon}</span>
            <span>{item.label}</span>
          </button>
        ))}
      </div>
      { marqueeText!==null && <marquee className="nav-marquee">
        {marqueeText}
      </marquee>}
    </div>
  );
}

export default NavBar;
